export const NON_DIGITS_PATTERN = /\D/g;
